export default {
  "zh-CN": {
    noLive: "暂无直播",
    noLiveTip: "主播开播后会第一时间出现在这里",
    enter: "进入直播间",
    back: "退出直播间",
    live: "直播中",
    actions: "直播间操作",
    watching: "{count} 热度",
    like: "点赞直播",
    loading: "正在连接真实直播…",
    failed: "直播加载失败",
    retry: "重新连接",
    queueLoading: "正在加载更多直播…",
    noNextLive: "暂时没有下一场直播",
    noPreviousLive: "已经是第一场直播",
    gifts: "赠送礼物",
    sendCompact: "赠送",
    game: "弹幕游戏",
    gameOpen: "打开直播弹幕游戏",
    gameTitle: "直播弹幕游戏",
    gameEmbedTip: "游戏由当前直播提供",
    gameFrameTitle: "直播弹幕游戏网页",
    gameLoading: "正在加载游戏…",
    gameFailed: "游戏暂时无法嵌入，请重试",
    gameRetry: "重新加载",
    gameClose: "关闭游戏",
    giftTitle: "为主播送上支持",
    balance: "余额 {count} 金币",
    availableBalance: "可用 {count} 金币",
    queuedCoins: "待赠送 {count} 金币",
    quantity: "数量",
    send: "赠送 {amount} 金币",
    sent: "{name} 送出 {gift} × {count}",
    comments: "评论",
    muted: "打开声音",
    unmuted: "关闭声音",
    quality: "清晰度",
    qualityTitle: "清晰度与画面",
    qualityAuto: "自动",
    qualityAutoTip: "根据网络情况自动选择，播放不稳定时逐级降低清晰度",
    quality_original: "原画",
    quality_full_hd: "超清",
    quality_hd: "高清",
    quality_sd: "标清",
    quality_standard: "标准",
    qualityVariant: "{label} · {code}",
    bitrate: "{value} kbps",
    frameRate: "{value} FPS",
    metadataPending: "等待视频元数据",
    displayMode: "画面显示",
    display_auto: "自动适配",
    display_contain: "完整显示",
    display_cover: "铺满屏幕",
    closeQualityPanel: "关闭清晰度面板",
    closePanel: "关闭礼物面板",
    emptyGift: "礼物目录暂不可用",
    chatTitle: "直播聊天",
    chatEmpty: "还没有聊天消息，来打个招呼吧",
    chatLogin: "登录后参与实时聊天",
    chatPlaceholder: "和直播间的大家聊聊…",
    chatSend: "发送聊天消息",
    viewersTitle: "直播间用户",
    viewersEmpty: "暂无在线登录用户",
    viewerRankTip: "按本场成功赠礼金币排序",
    paidCoins: "本场付费 {count} 金币",
    host: "主播",
    pinned: "常驻",
    closeViewers: "关闭用户列表",
    openUserActions: "与 {name} 互动",
    mention: "@直播间用户",
    mentionList: "选择要提及的用户",
    mentionUser: "@提及",
    viewProfile: "查看资料",
    tapGiftToSend: "点击上方礼物立即赠送"
  },
  "en-US": {
    noLive: "No live streams",
    noLiveTip: "Active creators will appear here as soon as they go live.",
    enter: "Enter live",
    back: "Leave live",
    live: "LIVE",
    actions: "Live room actions",
    watching: "{count} heat",
    like: "Like live",
    loading: "Connecting to the live stream…",
    failed: "Live stream failed to load",
    retry: "Reconnect",
    queueLoading: "Loading more live streams…",
    noNextLive: "No more live streams right now",
    noPreviousLive: "This is the first live stream",
    gifts: "Send gift",
    sendCompact: "Send",
    game: "Live game",
    gameOpen: "Open the live interactive game",
    gameTitle: "Live interactive game",
    gameEmbedTip: "Provided by this live session",
    gameFrameTitle: "Live interactive game page",
    gameLoading: "Loading game…",
    gameFailed: "The game cannot be embedded right now. Try again.",
    gameRetry: "Reload",
    gameClose: "Close game",
    giftTitle: "Support the creator",
    balance: "{count} coins available",
    availableBalance: "{count} coins available",
    queuedCoins: "{count} coins queued",
    quantity: "Quantity",
    send: "Send · {amount} coins",
    sent: "{name} sent {gift} × {count}",
    comments: "Comments",
    muted: "Turn sound on",
    unmuted: "Mute",
    quality: "Quality",
    qualityTitle: "Quality & display",
    qualityAuto: "Auto",
    qualityAutoTip: "Adapts to the network and steps down when playback is unstable",
    quality_original: "Original",
    quality_full_hd: "Full HD",
    quality_hd: "HD",
    quality_sd: "SD",
    quality_standard: "Standard",
    qualityVariant: "{label} · {code}",
    bitrate: "{value} kbps",
    frameRate: "{value} FPS",
    metadataPending: "Waiting for video metadata",
    displayMode: "Display mode",
    display_auto: "Auto fit",
    display_contain: "Fit entire video",
    display_cover: "Fill screen",
    closeQualityPanel: "Close quality panel",
    closePanel: "Close gift panel",
    emptyGift: "The gift catalog is unavailable",
    chatTitle: "Live chat",
    chatEmpty: "No messages yet. Say hello!",
    chatLogin: "Sign in to join the live chat",
    chatPlaceholder: "Chat with everyone in the room…",
    chatSend: "Send chat message",
    viewersTitle: "People in this live",
    viewersEmpty: "No signed-in viewers online",
    viewerRankTip: "Ranked by successful gifts in this live",
    paidCoins: "{count} coins spent here",
    host: "Host",
    pinned: "Pinned",
    closeViewers: "Close viewer list",
    openUserActions: "Interact with {name}",
    mention: "Mention someone",
    mentionList: "Choose someone to mention",
    mentionUser: "Mention",
    viewProfile: "View profile",
    tapGiftToSend: "Tap a gift above to send instantly"
  },
  "ar-SA": {
    noLive: "لا توجد بثوث مباشرة",
    noLiveTip: "سيظهر المبدعون هنا فور بدء البث.",
    enter: "دخول البث",
    back: "مغادرة البث",
    live: "مباشر",
    actions: "إجراءات غرفة البث",
    watching: "رواج {count}",
    like: "إعجاب بالبث",
    loading: "جارٍ الاتصال بالبث المباشر…",
    failed: "تعذر تحميل البث",
    retry: "إعادة الاتصال",
    queueLoading: "جارٍ تحميل المزيد من البثوث…",
    noNextLive: "لا توجد بثوث أخرى الآن",
    noPreviousLive: "هذا هو البث الأول",
    gifts: "إرسال هدية",
    sendCompact: "إرسال",
    game: "لعبة البث",
    gameOpen: "فتح لعبة البث التفاعلية",
    gameTitle: "لعبة البث التفاعلية",
    gameEmbedTip: "مقدمة من جلسة البث الحالية",
    gameFrameTitle: "صفحة لعبة البث التفاعلية",
    gameLoading: "جارٍ تحميل اللعبة…",
    gameFailed: "يتعذر تضمين اللعبة الآن. حاول مجددًا.",
    gameRetry: "إعادة التحميل",
    gameClose: "إغلاق اللعبة",
    giftTitle: "ادعم المبدع",
    balance: "الرصيد {count} عملة",
    availableBalance: "المتاح {count} عملة",
    queuedCoins: "قيد الإرسال {count} عملة",
    quantity: "الكمية",
    send: "إرسال مقابل {amount} عملة",
    sent: "أرسل {name} ‏{gift} × {count}",
    comments: "التعليقات",
    muted: "تشغيل الصوت",
    unmuted: "كتم الصوت",
    quality: "الجودة",
    qualityTitle: "الجودة وطريقة العرض",
    qualityAuto: "تلقائي",
    qualityAutoTip: "يتكيف مع الشبكة ويخفض الجودة تدريجيًا عند عدم استقرار التشغيل",
    quality_original: "الأصلية",
    quality_full_hd: "فائقة الدقة",
    quality_hd: "عالية الدقة",
    quality_sd: "قياسية",
    quality_standard: "عادية",
    qualityVariant: "{label} · {code}",
    bitrate: "{value} كيلوبت/ث",
    frameRate: "{value} إطار/ث",
    metadataPending: "بانتظار بيانات الفيديو",
    displayMode: "طريقة العرض",
    display_auto: "ملاءمة تلقائية",
    display_contain: "إظهار الفيديو كاملًا",
    display_cover: "ملء الشاشة",
    closeQualityPanel: "إغلاق لوحة الجودة",
    closePanel: "إغلاق لوحة الهدايا",
    emptyGift: "دليل الهدايا غير متاح",
    chatTitle: "الدردشة المباشرة",
    chatEmpty: "لا توجد رسائل بعد. ابدأ التحية!",
    chatLogin: "سجّل الدخول للمشاركة في الدردشة",
    chatPlaceholder: "تحدث مع الموجودين في الغرفة…",
    chatSend: "إرسال رسالة",
    viewersTitle: "الموجودون في البث",
    viewersEmpty: "لا يوجد مشاهدون مسجلون الآن",
    viewerRankTip: "الترتيب حسب الهدايا الناجحة في هذا البث",
    paidCoins: "تم إنفاق {count} عملة هنا",
    host: "المضيف",
    pinned: "مثبت",
    closeViewers: "إغلاق قائمة المشاهدين",
    openUserActions: "التفاعل مع {name}",
    mention: "الإشارة إلى شخص",
    mentionList: "اختر شخصًا للإشارة إليه",
    mentionUser: "إشارة",
    viewProfile: "عرض الملف الشخصي",
    tapGiftToSend: "اضغط على هدية أعلاه لإرسالها فورًا"
  }
}
